import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

const initState = {
  invoiceNo: null,
  status: null,
  filterStartDate: null,
  filterEndDate: null,
  paymentCategory: null,
};

export const PaymentReconciliationRecord = {
  name: "RecordListForm",
  initialState: initState,
  section: [
    {
      title: "RecordListForm",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "RecordListForm",
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="row"></div>,
          fields: [
            {
              id: "invoiceNo",
              label: "Search Invoice",
              Field_Name: "SearchInvoice",
              fieldType: FormFieldTypes.INPUT,
              dataField: "invoiceNo",
              fieldSetting: {
                placeholder: "Invoice No",
                allowSpace: false,
              },
              style: {
                containerCss: "col-lg-4 col-md-6",
              },
            },
            {
              id: "status",
              label: "Status",
              Field_Name: "Status",
              fieldType: FormFieldTypes.SELECT,
              dataField: "status",
              fieldSetting: {
                placeholder: "Select",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
              },
            },
            {
              id: "filterStartDate",
              label: "Start Date",
              Field_Name: "Start Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "filterStartDate",
              fieldSetting: {
                placeholder: "dd-mmm-yyyy",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
              },
            },
            {
              id: "filterEndDate",
              label: "End Date",
              Field_Name: "End Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "filterEndDate",
              fieldSetting: {
                placeholder: "dd-mmm-yyyy",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
              },
            },
            {
              id: "paymentCategory",
              label: "Payment Category",
              Field_Name: "paymentCategory",
              fieldType: FormFieldTypes.SELECT,
              dataField: "paymentCategory",
              fieldSetting: {
                placeholder: "Select",
                options: [
                ],
              },
              style: {
                containerCss: "col-lg-4 col-md-6 validation-left-0 ",
              },
            },
          ],
        },
      ],

    },
  ],
};
